export default{
  shipping_method: 'Shipping Method',
  shipping_time: 'Shipping Time',
  costs: 'Costs',
  shipping_to: 'Shipping To'
}


// WEBPACK FOOTER //
// ./src/i18n/en.js